import * as THREE from 'three';

import { degreeToRadian } from '../../shared';
import { icons, markerCanvasSize } from '../../../constants/Constants';

export class Marker extends THREE.Object3D {
    constructor(siblings, markerId, lat, long, camera, type) {
        super();

        this.lat = lat;
        this.long = long;
        this.camera = camera;
        this.markerId = markerId;
        // this.type = 'who';
        this.type = type;
        this.siblings = siblings;
        this.hasSiblings = siblings.length > 1;

        this.zoomMax = 1.49;
        this.zoomMin = 0.5;

        this.isCurrentFront = false;
        this.isFront = false;

        this.markerCanvas = document.getElementById(`marker-${this.markerId}`);
        this.markerContext = this.markerCanvas.getContext( '2d' );

        this.markerImg = new Image();
        this.markerImg.onload = () => {
            if(this.isFront){
                this._drawFrontTexture();
            }else {
                this._drawBackTexture();
            }
        };

        this.markerImg.src = `'./../assets/images/svg/${this._getIconImg(this.type)}`;

        this._initPlane();
        this._setLongLat();
    }

    _initPlane() {
        const plane = new THREE.PlaneGeometry(0.03, 0.03);
        const texture = new THREE.Texture(this.markerCanvas);
        // texture.anisotropy = 0;
        // texture.magFilter = THREE.NearestFilter;
        // texture.minFilter = THREE.NearestFilter;
        this.material = new THREE.MeshBasicMaterial({ map: texture, transparent: true });

        /**
         * depthTest !!! REALLY important, if true, it will have square corner on the canvas
         * @type {boolean}
         */
        this.material.depthTest = false;
        this.mesh = new THREE.Mesh(plane, this.material);
        this.mesh.position.set(0.53, 0, 0);
        this.mesh.rotateOnAxis(new THREE.Vector3(0, 1, 0), degreeToRadian(90));

        /**
         * renderOrder : marker is always on top of the globe
         */
        this.mesh.renderOrder = 5;

        this.add(this.mesh);
    }

    _setLongLat() {
        // marker.quaternion.setFromEuler(
        // new THREE.Euler(0, this._degreeToRadian(114.1767957), this._degreeToRadian(22.289729), "YZX")); // By mimosa, position of the mark (-180 to 180 degree)
        //Latitudes range from 0 to 90. Longitudes range from 0 to 180.
        // console.log('_setLongLat :', long, lat);
        this.quaternion.setFromEuler(
            new THREE.Euler(
                0,
                degreeToRadian(this.long),
                degreeToRadian(this.lat),
                'YZX'
            )
        );
    }

    updateScale(zoomLevel) {
        if( this.mesh.scale.x + zoomLevel < this.zoomMin) return;
        if( this.mesh.scale.x + zoomLevel > this.zoomMax) return;
        this.mesh.scale.x += zoomLevel;
        this.mesh.scale.y += zoomLevel;
    }

    setInitialDepth() {
        this.isCurrentFront = this.isFront;
    }

    testDepth(dist_globeCamera) {
        const a = this.camera.position;
        const b = new THREE.Vector3();
        this.mesh.getWorldPosition(b);
        const dist_markerCamera = a.distanceTo( b );
        this.isFront = ((dist_markerCamera - 0.1) <= dist_globeCamera);
    }

    updateTexture() {
        if(this.isFront){
            this._drawFrontTexture();
        }else {
            this._drawBackTexture();
        }
    }

    _drawFrontTexture() {
        const radius = 60;
        const imgScale = 0.4;

        this.markerContext.clearRect(0, 0, this.markerCanvas.width, this.markerCanvas.height);

        this.markerContext.beginPath();
        this.markerContext.arc(this.markerCanvas.width / 2, this.markerCanvas.height / 2, radius, 0, 2 * Math.PI, false);
        this.markerContext.fillStyle = 'rgba(255,255,255,0.6)';
        this.markerContext.fill();

        this.markerContext.beginPath();
        this.markerContext.arc(this.markerCanvas.width / 2, this.markerCanvas.height / 2, radius / 1.3, 0, 2 * Math.PI, false);
        this.markerContext.fillStyle = this._getIconColor(this.type);
        this.markerContext.fill();

        const posX = (markerCanvasSize - this.markerImg.width * imgScale ) * 0.5;
        const posY = (markerCanvasSize - this.markerImg.height * imgScale) * 0.5;

        this.markerContext.drawImage( this.markerImg, posX, posY, this.markerImg.width * imgScale, this.markerImg.height * imgScale);
    }

    _drawBackTexture() {
        const radius = 30;

        this.markerContext.clearRect(0, 0, this.markerCanvas.width, this.markerCanvas.height);

        this.markerContext.beginPath();
        this.markerContext.arc(this.markerCanvas.width / 2, this.markerCanvas.height / 2, radius, 0, 2 * Math.PI, false);
        this.markerContext.stroke();
        this.markerContext.strokeStyle = this._getIconColor(this.type);
        this.markerContext.lineWidth = 10;
    }

    update() {
        this.mesh.lookAt(this.camera.position);

        /**
         * isCurrentFront to prevent continuous texture updating.
         * */
        if(this.isCurrentFront !== this.isFront) {
            this.updateTexture();
            this.isCurrentFront = this.isFront;
        }

        if(this.material.map) {
            this.material.map.needsUpdate = true;
        }
    }


    _getIconColor(type) {
        for (let i = 0; i < icons.length; i++) {
            if (type === icons[i].type) return icons[i].color;
        }
        return null;
    }

    _getIconImg(type) {
        for (let i = 0; i < icons.length; i++) {
            if (type === icons[i].type) return icons[i].img;
        }
        return null;
    }

    getChildMesh() {
        return this.mesh;
    }

}
